import { useState } from 'react';

export type SnackbarSeverity = 'success' | 'error' | 'info' | 'warning';

/**
 * A custom hook for managing a standalone snackbar notifications state.
 * Use this hook when you are using the snackbar component directly in a component
 * rather than through the global snackbar store.
 */
export function useStandaloneSnackbar(defaults?: {
  severity?: SnackbarSeverity;
  message?: string;
  duration?: number;
}) {
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState<SnackbarSeverity>(
    defaults?.severity || 'error',
  );
  const [message, setMessage] = useState<string>(defaults?.message || '');
  const [duration, setDuration] = useState<number>(defaults?.duration || 3000);

  const showSnackbar = (opts?: {
    severity?: SnackbarSeverity;
    message?: string;
    duration?: number;
  }) => {
    setSeverity(opts?.severity || 'error');
    setMessage(opts?.message || '');
    setDuration(opts?.duration || 3000);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return {
    snackbarProps: {
      open,
      severity,
      message,
      autoHideDuration: duration,
      onClose: handleClose,
    },
    showSnackbar,
    handleClose,
  };
}
